import GoldenBaseView from "./goldenbase_view";
import ModuleBase, { implementFunction, bindButtonClickEvent }  from "../../../../../framework/core/mvvm/module_base";
import ModelData, { IUserData } from "../../../../public/model_data";
import { IUserCurrencyData } from "../../../../../manager/user_manager";
import ModuleManager from "../../../../../framework/core/module_manager";
import SceneManager from "../../../../../manager/scene_manager";
import Hall from "../../hall/hall";
import Record from "../../record/record";
import Rule from "../../rule/rule";


export default class GoldenBase extends ModuleBase<GoldenBaseView,null> {

    constructor() {
        super();
        this.windowPrefabResPath = "package/hall/module/goldentrance/hall_golden_base";
        this.viewType = GoldenBaseView;
    }

    public onShow(intentData){        
        super.onShow(intentData);

        let self = this;
        this.getUserData(ModelData.instance.roleData.id, (data: IUserData) => {
            self.view.setAvatar(data)
        })
    }

    @implementFunction('onSelfCurrencyDataUpdate')
    protected onSelfDataUpdate(data: IUserCurrencyData){

        this.view.updateCoin(data.chip);
    }

    @bindButtonClickEvent("BackBtn")
    private onBackBtn(){

        ModuleManager.instance.hideModule("GoldEntranceMatching");
        SceneManager.showHall("OpenFromGoldEntranceModule")
        SceneManager.lastEntranceOpenModuleName = ""
    }

    @bindButtonClickEvent("HelpBtn")
    private onHelpBtn(){
        ModuleManager.instance.showModule(Rule, {isSys:false})
    }

    @bindButtonClickEvent("RecordBtn")
    private onRecordBtn(){
        ModuleManager.instance.showModule(Record, "record")
    }



}